module.exports = __webpack_public_path__ + "static/img/video-pass.066a937c.png";